<form
  class="filter-dialog"
  *ngIf="filterForm"
  [formGroup]="filterForm"
  (ngSubmit)="onApply()"
>
  <div class="dialog-header">
    <h2>Filter By</h2>
    <button class="close-button" (click)="onCancel()" type="button">×</button>
  </div>

  <div class="dialog-content">
    <div class="filter-grid">
      <!-- Program -->
      <div class="filter-item">
        <div class="input-wrapper">
          <div class="label-row">
            <label for="program">Program</label>
          </div>
          <mat-select
            id="program"
            formControlName="program"
            multiple
            placeholder="Select Program"
          >
            <!-- Custom Trigger -->
            <mat-select-trigger>
              <!-- Show ALL if everything is selected -->
              @if (programSelection.length === filterData.program.length) {
                All
              } @else {
                {{
                  ComparisonNormalizer.string(programSelection[0]) === "all"
                    ? programSelection[1]
                    : programSelection[0] || ""
                }}
                @if (programSelection.length > 1) {
                  <span>
                    (+{{
                      programSelection.includes("All")
                        ? programSelection.length - 2
                        : programSelection.length - 1
                    }})
                  </span>
                }
              }

              <!-- Normal display -->
            </mat-select-trigger>

            <!-- Search Box -->
            <mat-form-field class="custom-select-input" appearance="outline">
              <input
                matInput
                [(ngModel)]="value"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onFilterChange($event)"
                placeholder="Search by program name..."
                (keydown.space)="$event.stopPropagation()"
              />
              @if (value) {
                <button
                  type="button"
                  mat-icon-button
                  matSuffix
                  (click)="clearFilter()"
                >
                  x
                </button>
              }
            </mat-form-field>

            <!-- Select All -->
            @if (filteredItemList.length > 0) {
              <mat-option
                [value]="'All'"
                (click)="toggleSelectAll()"
                (keydown.enter)="toggleSelectAll()"
              >
                {{ isAllSelected() ? "Deselect All" : "Select All" }}
              </mat-option>
            }

            <!-- Options -->
            @for (item of filteredItemList; track item) {
              <mat-option
                [value]="item"
                (click)="itemClicked(item)"
                (keydown.enter)="itemClicked(item)"
              >
                {{ item }}
              </mat-option>
            }

            <!-- No Results -->
            @if (filteredItemList.length === 0) {
              <mat-option disabled> No results found! </mat-option>
            }
          </mat-select>
        </div>
      </div>

      <!-- No. of Transcript -->
      <div class="filter-item">
        <div class="input-wrapper">
          <div class="label-row">
            <label for="no_of_transcripts">No. of Transcript</label>
          </div>
          <mat-select id="no_of_transcripts" formControlName="transcripts">
            @for (transcript of filterData.transcripts; track transcript) {
              <mat-option [value]="transcript">
                {{ transcript }}
              </mat-option>
            }
          </mat-select>
        </div>
      </div>

      <!-- Case Created (assignedDate) -->
      <div class="filter-item">
        <div class="input-wrapper">
          <div class="label-row">
            <label for="date_assigned">Case Created</label>
          </div>
          <div class="date-range-wrapper">
            <div
              class="date-input-wrapper"
              appCalender
              [startDate]="filterSelected.assignedDate.startDate"
              [endDate]="filterSelected.assignedDate.endDate"
              (dateRangeChanged)="onDateRangeChanged($event, 'assignedDate')"
              aria-labelledby="date_assigned"
            >
              <span>{{
                getFormattedRange("assignedDate") || "Select Date"
              }}</span>
              <svg
                class="calendar-icon"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Program Start Date -->
      <div
        class="filter-item"
        formGroupName="startDate"
        *ngIf="filterForm?.get('startDate')"
      >
        <div class="input-wrapper">
          <div class="label-row">
            <label for="program_start_date">Program Start Date</label>
          </div>
          <div class="date-range-wrapper">
            <div
              class="date-input-wrapper"
              appCalender
              [startDate]="filterSelected.startDate.startDate"
              [endDate]="filterSelected.startDate.endDate"
              [futureDate]="false"
              (dateRangeChanged)="onDateRangeChanged($event, 'startDate')"
              aria-labelledby="program_start_date"
            >
              <span>{{ getFormattedRange("startDate") || "Select Date" }}</span>
              <svg
                class="calendar-icon"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-actions">
    <button
      type="button"
      class="reset-all"
      [disabled]="!hasActiveFilters()"
      (click)="onResetAll()"
    >
      Reset All
    </button>
    <button
      class="cancel-btn mmp-btn-secondary"
      (click)="onCancel()"
      type="button"
    >
      Cancel
    </button>
    <button
      class="apply-btn mmp-btn-primary"
      [disabled]="!hasChanges()"
      type="submit"
    >
      Apply
    </button>
  </div>
</form>
